import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Woolverine,
  voices: {
    main: {
      description:
        "short-tempered raspy baritone, feral scrapper bite, rural northern grit, close dry mic with chest growl and frayed edges",
      seed: 10853,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "Anyone stands in my way, they won't be standin' much longer.",
      },
      { id: "select_2", text: "Woolverine's rarin' to go." },
      { id: "select_3", text: "Your boy Logan is ready for action." },
      { id: "select_4", text: "I'm ready, bub. Put me in." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Feel like I got a little extra punch in me for some reason…",
      },
      {
        id: "spawn_2",
        text: "Fire me up, Summers. And stay the hell outta my way.",
      },
      {
        id: "spawn_3",
        text: "You smell that in the air? That's potential bein' realized!",
      },
      { id: "spawn_4", text: "It's you an' me, Cajun, leadin' the charge!" },
      {
        id: "spawn_5",
        text: "I can finish this without even poppin' my claws.",
      },
      {
        id: "spawn_6",
        text: "Past, present, future. Don't matter. We gotta save 'em all.",
      },
      { id: "spawn_7", text: "Let's end this quick. Got better places to be." },
      { id: "spawn_8", text: "I came all the way from Krakoa for this?" },
      {
        id: "spawn_9",
        text: "This fight's gonna be over before it even gets started.",
      },
      {
        id: "spawn_10",
        text: "Somethin' tells me this is good day to have a healin' factor…",
      },
      {
        id: "spawn_11",
        text: "So, this is the end of all that is, eh? Not on my watch, darlin'…",
      },
      {
        id: "spawn_12",
        text: "Don't need enhanced senses to smell that somethin' is off here…",
      },
      {
        id: "spawn_13",
        text: "Don't matter how old I am. I can still take out any of you chumps.",
      },
      {
        id: "spawn_14",
        text: "Point me towards Dooms. I owe him some extra scars.",
      },
      {
        id: "spawn_15",
        text: "I'm the best there is at what I do, but what I do isn't very nice.",
      },
      {
        id: "spawn_16",
        text: "I've carried this rage since I was born…centuries ago…",
      },
      {
        id: "spawn_17",
        text: "You picked the wrong day to drag me into this mess, bub.",
      },
      {
        id: "spawn_18",
        text: "Been doin' this a long time. Ain't about to stop now.",
      },
      { id: "spawn_19", text: "I make this look good in any timeline." },
      { id: "spawn_20", text: "Got a problem, bub? Talk to the claws." },
      {
        id: "spawn_21",
        text: "This ain't my first rodeo. Sure as hell won't be my last.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "Like a bad penny. I just keep comin' back." },
      { id: "respawn_2", text: "Fully regenerated." },
      {
        id: "respawn_3",
        text: "You can put me down, but I always get back up.",
      },
      { id: "respawn_4", text: "The Woolverine don't go down that easy!" },
      { id: "respawn_5", text: "I've healed from a hundred times worse." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Berserker Rage!" }],
    ult_enemy: [{ id: "ult_enemy", text: "I am dropping you!" }],
    ability1: [
      { id: "ability1_1", text: "Let's do this!" },
      { id: "ability1_2", text: "Comin' at ya!" },
      { id: "ability1_3", text: "You're mine!" },
    ],
    kill: [
      { id: "kill_1", text: "You had that comin'." },
      { id: "kill_2", text: "Wasn't very nice, was it?" },
      { id: "kill_3", text: "I'd stay down if I were you." },
      { id: "kill_4", text: "That was embarrassin'." },
      { id: "kill_5", text: "You're outta your league, bub." },
    ],
    multikill: [
      { id: "multikill_1", text: "That's three!" },
      { id: "multikill_2", text: "Three down." },
      { id: "multikill_3", text: "Hat trick!" },
      { id: "multikill_4", text: "The hits keep comin'!" },
      { id: "multikill_5", text: "I'm on a roll!" },
      { id: "multikill_6", text: "Am I the only one doin' this?" },
      { id: "multikill_7", text: "And that should do it…" },
      { id: "multikill_8", text: "I think we're clear." },
      { id: "multikill_9", text: "Got 'em all!" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "About time I started healin'…" },
      { id: "low_hp_2", text: "Healin' factor finally kicked in." },
    ],
    healed: [
      { id: "healed_1", text: "Even better than my Mutant power!" },
      { id: "healed_2", text: "Needed a little boost. Thanks." },
      { id: "healed_3", text: "Some extra healin' never hurt." },
      { id: "healed_4", text: "A health boost? Fine by me." },
    ],
  },
} satisfies VoiceScript;

export default script;
